import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#030303] relative z-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-neon grid place-items-center">
                <Zap className="w-4 h-4 text-white" strokeWidth={2.5} />
              </div>
              <span className="font-display text-xl font-black">
                Boost<span className="text-gradient-neon">Up</span>
              </span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              The simplest way to grow your Instagram &amp; TikTok presence. Real reach, real results.
            </p>
          </div>
          <div>
            <div className="uppercase text-xs font-bold tracking-[0.2em] text-white/40 mb-4">
              Navigation
            </div>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="#pricing" className="hover:text-white">Pricing</a></li>
              <li><a href="#how" className="hover:text-white">How it works</a></li>
              <li><a href="#faq" className="hover:text-white">FAQ</a></li>
            </ul>
          </div>
          <div>
            <div className="uppercase text-xs font-bold tracking-[0.2em] text-white/40 mb-4">
              Legal
            </div>
            <p
              data-testid="instagram-disclaimer"
              className="text-xs leading-relaxed text-white/50 border border-white/10 p-4 rounded-lg bg-white/[0.02]"
            >
              BoostUp is not affiliated with, endorsed by, or in any way officially connected
              with Instagram or Meta Platforms, Inc. Instagram is a trademark of Meta
              Platforms, Inc. All product names, logos, and brands are property of their
              respective owners.
            </p>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} BoostUp. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <span>Built for creators, by creators.</span>
            <Link
              to="/affiliate"
              data-testid="footer-affiliate-link"
              className="text-white/40 hover:text-[#FF007F] transition"
            >
              Earn $$
            </Link>
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="text-white/30 hover:text-[#FF007F] transition"
            >
              Admin
            </Link>
            <Link
              to="/reseller"
              data-testid="footer-reseller-link"
              className="text-white/30 hover:text-[#FF007F] transition"
            >
              Reseller
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
